import { ArrowRight, Play, Instagram, Video } from "lucide-react";

const KOLSection = () => {
  const kolVideos = [
    { views: "34.8萬", title: "宜蘭包棟民宿 旅宿A幸福和苑", image: "/assets/kol_348k.jpg", url: "https://www.instagram.com/reel/DLuZwEJSHi1/" },
    { views: "66.8萬", title: "合作影片精選", image: "/assets/kol_collab.jpg", url: "https://www.instagram.com/reel/DNVZ4qGvyLy/", objectPosition: "center 20%" },
    { views: "17.5萬", title: "竟然可以直接到達瀑布", image: "/assets/kol_waterfall.jpg", url: "https://www.instagram.com/reel/DN0VCcj5s3h/" },
    { views: "48.2萬", title: "宜蘭三星鄉民宿精選", image: "/assets/kol_sanxing.jpg", url: "https://www.instagram.com/reel/DVIxlsFoJcf/" },
    { views: "22.1萬", title: "三位大網紅出演", image: "/assets/kol_3stars.jpg", url: "https://www.instagram.com/reel/DOdaR9KkgFe/", objectPosition: "center 20%" },
    { views: "108.7萬", title: "白石數位旅宿專家Bob", image: "/assets/kol_bob.jpg", url: "https://www.instagram.com/reel/DEmnGSLNe1W/" },
  ];

  return (
    <section data-testid="kol-section" className="py-14 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-12">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#0A2540] text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
            <Video className="w-4 h-4" />
            星鏈 KOL 品牌管理
          </div>
          <h2 className="text-2xl sm:text-4xl font-bold text-[#0A2540] tracking-tight mb-4">
            500+ 網紅合作導流
          </h2>
          <p className="text-base md:text-lg text-[#475569] max-w-2xl mx-auto px-2">
            累積總觀看數超過 <span className="font-bold text-[#FF6B00]">480 萬+</span>，將流量有效轉換為實際訂單
          </p>
        </div>

        {/* KOL Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 mb-10 md:mb-12">
          <div className="bg-gradient-to-br from-[#FF6B00] to-[#E65A00] rounded-2xl p-4 md:p-6 text-white text-center">
            <div className="text-3xl md:text-4xl font-black mb-1 md:mb-2">500+</div>
            <div className="text-xs md:text-base text-white/80">合作網紅</div>
          </div>
          <div className="bg-gradient-to-br from-[#0A2540] to-[#163859] rounded-2xl p-4 md:p-6 text-white text-center">
            <div className="text-3xl md:text-4xl font-black mb-1 md:mb-2">480萬+</div>
            <div className="text-xs md:text-base text-white/80">累積觀看數</div>
          </div>
          <div className="bg-gradient-to-br from-[#FF6B00] to-[#E65A00] rounded-2xl p-4 md:p-6 text-white text-center">
            <div className="text-3xl md:text-4xl font-black mb-1 md:mb-2">150+</div>
            <div className="text-xs md:text-base text-white/80">宣傳影片</div>
          </div>
          <div className="bg-gradient-to-br from-[#0A2540] to-[#163859] rounded-2xl p-4 md:p-6 text-white text-center">
            <div className="text-3xl md:text-4xl font-black mb-1 md:mb-2">13hrs</div>
            <div className="text-xs md:text-base text-white/80 leading-snug">10:00-23:00 專人接單</div>
          </div>
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {kolVideos.map((video) => (
            <a key={video.title} href={video.url} target="_blank" rel="noopener noreferrer" className="group relative bg-slate-100 rounded-2xl overflow-hidden aspect-video cursor-pointer hover:shadow-xl transition-all duration-300 block">
              <img src={video.image} alt={video.title} className="w-full h-full object-cover" style={video.objectPosition ? { objectPosition: video.objectPosition } : undefined} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                  <Play className="w-8 h-8 text-white ml-1" />
                </div>
              </div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="text-[#FF6B00] font-black text-xl mb-1">{video.views}</div>
                <div className="text-white font-semibold text-sm">{video.title}</div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="https://www.instagram.com/lakezetw/" target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#FF6B00] font-bold hover:underline">
            <Instagram className="w-5 h-5" />
            查看更多合作影片
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default KOLSection;
